<mat-form-field
  [formGroup]="group"
  [ngClass]="loading ? 'nsc-form-field-loading' : ''">
  <mat-select 
   role="listbox"
   id="{{idx}}"
   formControlName="{{ controlName }}"
   autocomplete="off"
    placeholder="{{ placeholder }}"
   [attr.aria-expanded]="selectedValue.opened"
   (openedChange)="openedChange($event)"
   (selectionChange)="changeValue($event)" >
    <mat-optgroup  role="group" *ngFor="let obj of selectObjects" [label]="obj.label" id="{{idx}}_group">
      <mat-option  [attr.aria-selected]="obj2.value === selectedValue.id" role="option" id="{{idx}}_{{i}}" *ngFor="let obj2 of obj.options; let i = index;" [value]="obj2.value" [attr.aria-label]="obj2.name">
        {{ obj2.name }}
      </mat-option>
    </mat-optgroup>
  </mat-select>
  <mat-hint>{{ hint }}
    <span  aria-live="polite" [attr.aria-label]="selectedValue.name"></span>
    <span  [attr.aria-label]="required ? 'required': ''"  ></span> 
  </mat-hint>
  <mat-error *ngIf="group.controls[controlName].invalid" [attr.aria-label]="hint + validationMessage.get(group.controls[controlName], placeholder) ">{{ hint }} {{ validationMessage.get(group.controls[controlName], placeholder) }}</mat-error>
</mat-form-field>
